export const LISTS_CONSTANTS = {
  GET_LISTS_REQUEST: 'GET_LISTS_REQUEST',
  GET_LISTS_SUCCESS: 'GET_LISTS_SUCCESS',
  GET_LISTS_FAILURE: 'GET_LISTS_FAILURE',
}
